import React, { Component } from "react";
import { Link } from "react-router-dom";

class RegistrationLink extends Component {
  render() {
    return (
      <div className="container">
        Please{" "}
        <Link to="../SignInForm" className="btn btn-primary">
          Sign In
        </Link>{" "}
        to continue
      </div>
    );
  }
}

export default RegistrationLink;
